import React, { memo } from "react";
import CheckBox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useAppDispatch, useAppSelector } from "../app/hooks/reduxHooks";
import { handleChange } from "../app/formSlice";
import styles from './CheckBoxes.module.sass'

function CheckBoxes() {
  const dispatch = useAppDispatch();
  const firstValue = useAppSelector((state) => state.form.firstCheckBox);
  const secondValue = useAppSelector((state) => state.form.secondCheckBox);
  const setValue = (e) => {
    dispatch(
      handleChange({
        name: e.target.name,
        value: e.target.checked,
      })
    );
  };
  return (
    <div className={styles.root}>
      <FormControlLabel
        className={styles.noPad}
        control={
          <CheckBox
            name="firstCheckBox"
            checked={firstValue}
            onChange={setValue}
            icon={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#575452"/>
          </svg>}
            checkedIcon={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="4" width="8" height="8" rx="2" fill="#154C03"/>
            <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#575452"/>
          </svg>}
          />
        }
        label={
          <p className={styles.p}>
            Autorizzo il trattamento dei miei dati al fine di dare seguito alla
            mia richiesta come indicato nell'informativa
          </p>
        }
      />
      <FormControlLabel
        className={styles.noPad}
        control={
          <CheckBox
            name="secondCheckBox"
            checked={secondValue}
            onChange={setValue}
            icon={(
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#575452"/>
              </svg>
            )}
            checkedIcon={(
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="8" height="8" rx="2" fill="#154C03"/>
                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#575452"/>
              </svg>
            )}
          />
        }
        label={
          <p className={styles.p}>
            Accetto il trattamento dei miei dati per l’invio di comunicazioni
            promozionali da Refin come indicato nell’informativa
          </p>
        }
      />
      <p className={styles.warn}>
        È possibile modificare le proprie preferenze e disiscriversi in qualsiai
        momento scrivendo a{" "}
        <a className={styles.a} href="https://privacy@refin.it">
          privacy@refin.it
        </a>
      </p>
    </div>
  );
}

export default memo(CheckBoxes);
